import Immutable from 'immutable';

import {
	webapi,
	createModuleState,
	EntitySearchAndDetailModel,
	DefinitionUtils,
	EntityDetailModel,
	FormDefinition as Form,
	FormItemDefinition as FormItem,
	CrossDefinition as Cross,
	CentererDefinition as Centerer,
	ButtonDefinition as Button,
	ContextValidator,
	DateUtils,
	REPORTED_EXCEPTION,
	updateEntityTimestamp
} from 'ps-gui';
import {
	getColumnText,
	getPhrase
} from '../data/phrases';
import { createSearchModel } from './utils';

const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('SystemMaintenance');

export default class SystemMaintenanceModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setInitialized() {
		return new SystemMaintenanceModel(this.#data.set('initialized', true));
	}

	initialize() {
		let srch = createSearchModel('/api/dq/sv_system_maintenance');
		return this.setEntitySearchAndDetail(
			new EntitySearchAndDetailModel()
				.setSearch(srch)
				.setDetail(getDetailModel())
				.setEntityName('systemMaintenance')
				.setNewRowMode(EntitySearchAndDetailModel.NEW_ROW_MODE_EMPTY)
		).#setInitialized();
	}

	setEntitySearchAndDetail(model) {
		return new SystemMaintenanceModel(this.#data.set('esad', model.getState()));
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}

function detailReadOnly(ctx) {
	return ctx.getProperty('isDeleted') === 'Y' || ctx.getProperty('isActive') === 'N';
}

let detailDefinition = Centerer(Form().setOpacity(ctx => ctx.getProperty('isDeleted') === 'Y' ? '0.3' : '1').setVirtual(false).setBasePath('detail').setItems([
	Cross().setItems([
		FormItem('fromDate', 'date').setMandatory(true).setWithTime(true).setReadOnly(detailReadOnly).setLabel(getColumnText('maintenanceFrom')),
		FormItem('toDate', 'date').setMandatory(true).setWithTime(true).setReadOnly(detailReadOnly).setLabel(getColumnText('maintenanceTo')),
		FormItem('notificationFromDate', 'date').setMandatory(true).setWithTime(true).setReadOnly(detailReadOnly),
	]).setValidator(ContextValidator((errors, ctx, itemName) => {
		const fromDate = ctx.getProperty('fromDate');
		const toDate = ctx.getProperty('toDate');
		const notifFromDate = ctx.getProperty('notificationFromDate');
		errors.add(
			ctx.getFullPath('toDate'),
			fromDate && toDate && DateUtils.compareDates(fromDate, toDate) >= 0 ? getPhrase('maintenanceToMustBeGreaterThanMaintenanceFrom') :
				fromDate && toDate && DateUtils.compareDates(DateUtils.truncate(fromDate), DateUtils.truncate(toDate)) ? getPhrase('maintenanceFromAndToMustBeSameDay') : null,
			'toDateLteFromDate'
		);
		errors.add(
			ctx.getFullPath('notificationFromDate'),
			fromDate && notifFromDate && DateUtils.compareDates(notifFromDate, fromDate) >= 0 ? getPhrase('notificationFromDateMustBeLessThanMaintenanceFrom') : null,
			'notifDateGteFromDate'
		);
	})),
	FormItem('comments', 'text').setMultiline(true).setReadOnly(ctx => ctx.getProperty('isDeleted') === 'Y'),
	Cross().setItems([Button('delete', getPhrase('delete')).setListener(async e => {
		const ctx = e.ctx;
		let res = await webapi.execute('/api/proc/API_SystemSettings/deleteSystemMaintenance', {
			id: ctx.getProperty('id')
		});
		if (res === REPORTED_EXCEPTION) {
			return;
		}
		updateEntityTimestamp('systemMaintenance');
		ctx.setModel(await ctx.getModel().reload());
	})]).setJustifyContent('right').setVisible(ctx => ctx.getProperty('isActive') === 'Y' && ctx.getProperty('isDeleted') === 'N')
])).setMaxWidth('800px');

let detailModel = null;

export function getDetailModel() {
	if (!detailModel) {
		DefinitionUtils.setLabels(detailDefinition);

		detailModel = new EntityDetailModel()
			.setLoadUri('/api/proc/api_systemsettings/getSystemMaintenanceDetail')
			.setSaveUri('/api/proc/api_systemsettings/saveSystemMaintenance')
			.setDefinition(detailDefinition)
			.setEntityName('systemMaintenance');
	}
	return detailModel;
}

